import { ETaskLocation } from "@rentiohq/shared-frontend/dist/types/task.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  ERentioFormField,
  IUiSchema,
} from "@rentiohq/web-shared-next/dist/utils/types/form";
import { EField } from "./schema.reportProblem.types";

export const uiSchema = (): IUiSchema => {
  return {
    fields: [
      {
        fieldKey: EField.Subject,
        required: true,
        uiComponent: ERentioFormField.TextField,
        title: getLocalizedText("system.subject"),
      },
      {
        fieldKey: EField.Description,
        optional: true,
        uiComponent: ERentioFormField.TextArea,
        title: getLocalizedText("system.description"),
      },
      {
        fieldKey: EField.Location,
        optional: true,
        uiComponent: ERentioFormField.Select,
        title: getLocalizedText("system.location"),
        componentProps: {
          options: Object.values(ETaskLocation).map(location => ({
            value: getLocalizedText(`task.location.${location.toLowerCase()}`),
            id: location,
          })),
        },
      },
      {
        fieldKey: EField.Attachments,
        optional: true,
        uiComponent: ERentioFormField.Attachment,
        title: getLocalizedText("tenant.system.attachments"),
        componentProps: {
          multiple: true,
        },
      },
    ],
  };
};
